module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_1024.5d54f33a.webp";